import React from "react";
import { useParams } from "react-router-dom";
import { FileSignature } from "lucide-react";
import { PageHeader } from "../../components/common";
import { SafLogReport } from "../../components/saf/SafLogReport";

/**
 * Phase 207 — Reports › SAF Approval and Modification Log (Municipal Admin).
 * Every action on citizen self-assessments — Submitted, Assigned, Verified by Collector, Demand Modified, Approved by Supervisor,
 * Sent Back, Final Approved, Rejected — with who did it (name + ID), role, remarks and old / new demand values. Excel export.
 */
export default function SafLog() {
  const { code } = useParams();
  return (
    <div data-testid="admin-saf-log-page">
      <PageHeader title="SAF Approval and Modification Log"
        subtitle="Who did what on every citizen self-assessment, when and why — submissions, collector verification, demand modifications (old / new values), supervisor and final approvals, send-backs and rejections. Filter by date, Zone, Ward, PIN, owner, SAF number, action, staff member or role and export to Excel.">
        <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"><FileSignature className="h-3.5 w-3.5" aria-hidden="true" /> Citizen self-assessments</span>
      </PageHeader>
      <SafLogReport code={code} testId="admin-saf-log" propertyPath={(r) => `/${code}/admin/properties?focus=${r.property_id}`} />
    </div>
  );
}
